<template>
  <div class="opple-device-msg-control">
    <div v-if="!!tip" class="opple-device-msg-control_tip">
      {{ tip }}
    </div>
    <div class="scence_allset_title">
      <ul
        v-show="$route.name !== 'detailDetach'"
        class="oper_ul"
      >
        <!-- // 移动-->
        <OppleAuth v-if="!noMoveList.includes(model.ClassSku) && getButtonShow('move')" code="MoveDevice">
          <li>
            <template v-if="model.ClassSku === '0x001C3003' && Number(model.ChildId) === 65535">
              <span :class="[activeBtn=== 1 ? 'curr_card' : 'disable']"><i class="icon-3" /></span>
            </template>
            <template v-else>
              <span
                :class="[activeBtn === 1 ? 'curr_card' : '']"
                @click="addList1"
              ><i class="icon-3" /></span>
            </template>
            <p>{{ $t('deviceMsg.move') }}</p>
          </li>
        </OppleAuth>
        <!-- // 替换-->
        <OppleAuth v-if="!noReplaceListPlus.includes(model.ClassSku) && isShowReplace && getButtonShow('replace')" code="ReplaceDevice">
          <li>
            <template v-if="Number(model.ChildId) === 65535 && !noReplaceList.includes(model.ClassSku)">
              <span
                :class="[activeBtn === 2 ? 'curr_card' : '']"
                @click="addList2"
              ><i class="icon-14" /></span>
            </template>
            <template v-else>
              <span class="disable"><i class="icon-14" /></span>
            </template>
            <p>{{ $t('deviceMsg.replace') }}</p>
          </li>
        </OppleAuth>
        <!-- // 删除-->
        <OppleAuth v-if="!noDeleteList.includes(model.ClassSku) && getButtonShow('del')" code="DeleteDevice">
          <li>
            <template v-if="Number(model.ChildId) === 65535">
              <span
                :class="[activeBtn === 3 ? 'curr_card' : '']"
                @click="addList3"
              ><i class="icon--1" /></span>
            </template>
            <template v-else>
              <span :class="[activeBtn === 3 ? 'curr_card' : 'disable']"><i class="icon--1" /></span>
            </template>
            <p>{{ $t('deviceMsg.delete') }}</p>
          </li>
        </OppleAuth>
        <!-- // 校准-->
        <OppleAuth v-if="(calibrateReferAbility || calibrateTempReferAbility || curtainCalibrateAction) && getButtonShow('calibrate')" code="AddDevice">
          <li>
            <template v-if="Number(model.ChildId) === 65535">
              <span
                :class="[activeBtn === 6 ? 'curr_card' : '']"
                @click="addList6"
              ><i class="svg_calibrate" /></span>
            </template>
            <template v-else>
              <span class="disable"><i class="svg_calibrate" /></span>
            </template>
            <p>{{ $t('deviceMsg.calibrate') }}</p>
          </li>
        </OppleAuth>
        <!-- 窗帘校准-->
        <!-- <OppleAuth v-if="curTainAction !== null" code="AddDevice">
          <li>
            <span
              :class="[activeBtn === 6 ? 'curr_card' : '']"
              @click="jiaozhunChuanglian"
            ><i class="svg_calibrate" /></span>
            <p>{{ $t('deviceMsg.calibrate') }}</p>
          </li>
        </OppleAuth> -->
        <!-- // 没有重启能力,隐藏 -->
        <OppleAuth v-if="deviceReboot && getButtonShow('restart')" code="RebootDevice">
          <li>
            <template v-if="Number(model.ChildId) === 65535">
              <span
                :class="[activeBtn === 5 ? 'curr_card' : '']"
                @click="addList5"
              ><i class="icon-23" /></span>
            </template>
            <template v-else>
              <span class="disable"><i class="icon-23" /></span>
            </template>
            <p>{{ $t('deviceMsg.restart') }}</p>
          </li>
        </OppleAuth>
        <OppleAuth v-if="isShowChildReset" code="DeleteDevice">
          <li>
            <span
              :class="[activeBtn === 7 ? 'curr_card' : '']"
              @click="handlerJdqFw"
            ><i class="icon-18" />
            </span>
            <p>{{ $t('deviceMsg.resetRelayDevice') }}</p>
            <!-- <p>{{ $t('deviceMsg.restart') }}</p> -->
          </li>
        </OppleAuth>
      </ul>
    </div>
    <OppleQaModal
      :visible="isShowQaModal"
      :v-device-id="model.VDeviceId"
      @ok="onOppleQaModalOk"
      @close="onOppleQaModalClose"
    />
    <OppleChildReset
      :visible="isShowOppleChildReset"
      :v-device-id="model.VDeviceId"
      :child-list="childEnumValue"
      :model="model"
      @ok="isShowOppleChildReset = false"
      @close="isShowOppleChildReset = false"
    />
  </div>
</template>
<script>
import moment from 'moment'
import DeviceTianMuMixin from '@/components/Mixin/DeviceTianMuMixin'
import OppleQaModal from './OppleQaModal'
import OppleChildReset from './OppleChildReset'
import { CallAction, FindDeviceAbilityByVDeviceId, ResetDevicesInChannel } from '@/axios/IDevice.js'
import { warning } from '@/assets/js/common.js'

function formatCountdown(milliseconds) {
  // 处理负数情况（如果时间差为负，表示倒计时已结束）
  if (milliseconds < 0) {
    return "00:00";
  }

  // 计算总秒数（向下取整）
  const totalSeconds = Math.floor(milliseconds / 1000);
  
  // 计算分钟和秒数
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  
  // 补零格式化（确保两位数显示）
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');
  
  return `${formattedMinutes}:${formattedSeconds}`;
}


export default {
  components: {
    OppleChildReset,
    OppleQaModal
  },
  mixins: [DeviceTianMuMixin],
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    configAbility: {
      type: Object,
      default: () => ({})
    },
    calibrateReferAbility: {
      type: Boolean,
      default: false
    },
    calibrateTempReferAbility: {
      type: Boolean,
      default: false
    },
    isShuanglu: {
      type: Boolean,
      default: false
    },
    isShowChildReset: {
      type: Boolean,
      default: false
    },
    actionSet: {
      type: Array,
      default: () => ([])
    },
    uISet: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      startChuanglianTime: null,
      chuanglianTimer: null,
      tip: '',
      curTainAction: null,
      activeBtn: -1,
      noDeleteList: ['0x001F0900','0x001F0013'], // 没有删除的设备
      noReplaceList: ['0x001F000C','0x001F000B','0x001F000A','0x001F0009','0x0010051C','0x001F0900'], // 没有替换的设备
      noReplaceListPlus: [ '0x001F0900', '0x001F0013' ],
      noMoveList: [ '0x001F0013' ],// 没有移动的设备
      // blue_set1: false, // 移动按钮显示隐藏
      // blue_set2: false, // 替换按钮显示隐藏
      // blue_set3: false, // 删除按钮显示隐藏
      // blue_set4: false, // 恢复出厂设置按钮显示隐藏
      // blue_set5: false, // 重启按钮显示隐藏
      // blue_set6: false, // 校准按钮显示隐藏
      isShowReplace: true, //是否显示替换按钮
      deviceReboot: false, //判断设备重启能力是否存在
      isShowQaModal: false,
      isShowOppleChildReset: false,
      childEnumValue: [],
      childEnumValueMap: [],
      // appShowMode=1024 的特殊能力（如窗帘校准）不会在常规能力区展示，映射到顶部操作按钮
      curtainCalibrateAction: null,
    }
  },
  watch: {
    configAbility(value) {
      this.isShowReplace = typeof value.ReplaceSupport === 'boolean' ? value.ReplaceSupport : true;
      this.deviceReboot = value.Reboot;
    },
    actionSet(actionList) {
      let childReset = null;
      let curtainCalibrateAction = null;
      
      (actionList || []).forEach(action => {
        childReset = (action.ActionList || []).find(item =>
          item.UI?.ResetRelayConnectedDevices === 1
        );
        if (!curtainCalibrateAction) {
          curtainCalibrateAction = (action.ActionList || []).find(item => {
            const appShowMode = item?.UI?.ShowCondition?.appShowMode ?? item?.ShowCondition?.appShowMode;
            return Number(appShowMode) === 1024;
          });
        }
      })

      if (childReset) {
        const childValue = childReset.Values?.find(item => item.IsShow === true);

        if (childValue) {
          this.childEnumValue = childValue.EnumValue.map((item, index) => {
            return {
              ...item,
              tip: (childValue.UI?.EnumValueMap || [])[item.Value] || {}
            }
          });
        }
      }

      this.curtainCalibrateAction = curtainCalibrateAction;
    }
  },

  destroyed() {
    clearTimeout(this.chuanglianTimer);
  },

  methods: {
    changeActiveBtn(index) {
      this.activeBtn = index;
    },

    /* 点击移动按钮
     */
    addList1 () {
      this.changeActiveBtn(1);
      this.$emit('onDeviceControlChange', {
        type: 'removedevice',
        payload: this.model
      })
    },
    /* 点击替换
     */
    async addList2 () {
      this.changeActiveBtn(2);

      try {
        if (this.isShuanglu) {
          this.isShowQaModal = true;
        } else {
          this.$emit('onDeviceControlChange', {
            type: 'replacedevice',
            payload: this.model
          })
        }
      } catch {

      }
    },

    /* 点击删除按钮
     */
    addList3 () {
      this.changeActiveBtn(3);
      this.$emit('pannelControl', 2);
    },
    /* 点击恢复出厂设置按钮
     */
    addList4 () {
      this.changeActiveBtn(4);
      this.$emit('pannelControl', 3);
    },
    /* 点击重启按钮
     */
    addList5 () {
      this.changeActiveBtn(5);
      this.$emit('pannelControl', 4);
    },
    /* 点击校准按钮
     */
    addList6 () {
      this.changeActiveBtn(6);
      if (this.calibrateReferAbility || this.calibrateTempReferAbility) {
        this.$emit('calibrateShow', true);
        return;
      }
      if (this.curtainCalibrateAction) {
        this.$emit('triggerCurtainCalibrate', this.curtainCalibrateAction);
      }
    },

    handlerJdqFw() {
      this.changeActiveBtn(7);
      this.isShowOppleChildReset = true;
    },

    onOppleQaModalClose() {
      this.isShowQaModal = false;
    },

    onOppleQaModalOk() {
      this.isShowQaModal = false;
      this.$emit('onDeviceControlChange', {
        type: 'replacedevice',
        payload: this.model
      })
    },

    // handlerChuangLisnJiaozhun() {
    //   const { actionSet, uISet, model } = this;

    //   if (
    //     uISet &&
    //     uISet.CurTainRouteAction && 
    //     actionSet && 
    //     actionSet[0] && 
    //     actionSet[0].ActionList &&
    //     model &&
    //     model.DeviceId
    //   ) {
    //     const { Code } =  uISet.CurTainRouteAction;
    //     const curTainAction = actionSet[0].ActionList.find(item => item.Code === Code);

    //     if (!!curTainAction) {
    //       this.curTainAction = curTainAction;

    //       const curStatus =  model.StatusInfo.find(
    //         item => item.StatusType === uISet.CurTainRouteAction.InitStatusType
    //       );

    //       if (`${curStatus.Value}` === '254') {
    //         this.tip = '请校准窗帘, 完成行程设置后，窗帘开合会更准确，也能正常使用智能场景。';
    //       };
    //     };
    //   };
    // },

    // showChuangLianModal() {
    // },

    // jiaozhunChuanglian() {
    //   const params = {
    //     vDeviceId: this.model.VDeviceId,
    //     msgType: this.curTainAction.MsgType,
    //     channelId: this.curTainAction.ChannelId,
    //     values: this.curTainAction.Values.map(item => item.DefaultValue).join(',')
    //   };

    //   // CallAction(params);

    //   this.startChuanglianTime = new Date().getTime()
    //   this.startLoopChuanglianJiaozhun();
    // },

    // startLoopChuanglianJiaozhun() {
    //   this.chuanglianTimer = setInterval(async () => {
    //     const res = await FindDeviceAbilityByVDeviceId({
    //       VDeviceId: this.model.VDeviceId,
    //     });

    //     if (res && res.StatusCode === 0 && res.Result) {
    //       const { UISet } = res.Result;
    //       const minsTime = new Date().getTime() - this.startChuanglianTime;

    //       if (`${UISet.CurTainRouteAction.CheckStatusWithValue}` === '0') {
    //         this.tip = '';

    //         clearInterval(this.chuanglianTimer);
    //       } else if (minsTime > UISet.CurTainRouteAction.MaxWaitCheckTime) {
    //         this.tip = '';

    //         warning(this,'校准失败');
    //         clearInterval(this.chuanglianTimer);
    //       } else {
    //         const time = formatCountdown(UISet.CurTainRouteAction.MaxWaitCheckTime - minsTime);

    //         this.tip = `请校准窗帘, 完成行程设置后，窗帘开合会更准确，也能正常使用智能场景。倒计时: ${time}`;
    //       };
    //     };
    //   }, 1000);
    // },
  }
}
</script>

<style lang="scss" scoped>
.svg_calibrate {
  height: 100%;
  background-position: 50%;
  background-image: url('../../assets/img/svg/jiaozhun_1.svg');
  background-repeat: no-repeat;
  &:hover {
    background-color: #619df1;
    background-image: url('../../assets/img/svg/jiaozhun_h.svg');
  }
}
// .curr_card .svg_calibrate {
//   background-image: url('../../assets/img/svg/jiaozhun_h.svg');
// }
.disable .svg_calibrate {
  opacity: 0.1;
  background-image: url('../../assets/img/svg/jiaozhun.svg');
}

.opple-device-msg-control {
  position: relative;
  padding-top: 41px;

  &_tip {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 26px;
    // line-height: 26px;
    padding: 4px;
    background-color: #f79b15;
    color: #fff;
  }
};
</style>
<style scoped>
.oper_ul:hover {
  cursor: pointer;
}

</style>